import service, { getCookie } from "Utility/Service";
import { useQuery } from "react-query";
import { AxiosRequestConfig } from "axios";
import { Config } from "./type";

//從網路獲取配置資訊的異步函式
const getConfig = async (): Promise<Config> => {
  const config: AxiosRequestConfig = {
    method: "get",
    url: "/api/config",
  };
  // 執行 HTTP GET 請求，並返回網路請求的結果
  const { data } = await service(config);
  return data;
};

// 自訂 Hook 用於使用 React Query 獲取配置資訊

export const useConfig = () => {
  return useQuery(["config"], () => getConfig());
};

//////////////////////////////////////////////////////////////////////////////////////////

// 側邊欄顯示狀態 API
const functionAllow = async () => {
  // TODO: 新增 csrftoken驗證，減少第一次錯誤呼叫 #250630
  // const token = getCookie("csrftoken");
  // if (!token) {
  //   // 沒有 token，直接跳過或拋錯
  //   throw new Error("No CSRF token");
  // }
  const body: any = { function: {} };

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/function_allow",
    data: body,
  };
  // 執行 HTTP POST 請求，並返回網路請求的結果
  const { data } = await service(config);

  return data;
};
// 回傳 側邊欄 顯示狀態
export const useFunctionAllow = () => {
  return useQuery(["get-function-allow"], () => functionAllow());
};
